import React, {ReactNode} from 'react';
import {Price, PriceV2} from '../../../types/Price';
import {ProductCardBase} from './ProductCardBase';
import {ProductCardDescription} from './ProductCardDescription';
import {ProductCardImage} from './ProductCardImage';
import {ProductCardItemPrice} from './ProductCardItemPrice';

type ProductInfo = {
  path: string;
  name: string;
  colorLabel: string;
  image: {
    src: string;
    description: string;
    isEnclosed: boolean;
  };
  brand: string;
  sizeLabel: string;
  lowStockHint?: string;
  id: number;
};

type QuantityInfo = {
  quantity: number;
  maxQuantity: number;
};

export interface ProductCardProps {
  product: ProductInfo;
  totalPrice: Price | PriceV2;
  unitPrice: Price;
  badges: ReactNode;
  additionalBadge?: ReactNode;
  quantity: QuantityInfo;
  wishlistButton?: ReactNode;
  quantityBlock?: ReactNode;
  deleteBlock?: ReactNode;

  // Tracking
  trackProductsOriginClick?: () => void;
  trackProductClick?: () => void;

  sellingMerchant?: React.ReactNode;
  className?: string;
  lowestPriorPrice?: string;
  overflowHiddenLPL30D?: boolean;
  icon?: React.ReactNode;
  openInNewTab?: boolean;
}

export const ProductCard: React.FC<ProductCardProps> = ({
  product,
  totalPrice,
  unitPrice,
  deleteBlock,
  badges,
  wishlistButton,
  additionalBadge,
  quantity,
  quantityBlock,
  trackProductsOriginClick,
  trackProductClick,
  sellingMerchant,
  className,
  lowestPriorPrice,
  icon,
  overflowHiddenLPL30D,
  openInNewTab,
}) => {
  return (
    <ProductCardBase
      className={className}
      imageBlock={
        <ProductCardImage
          product={product}
          badges={badges}
          icon={icon}
          wishlistButton={wishlistButton}
          trackProductClick={trackProductClick}
          trackProductsOriginClick={trackProductsOriginClick}
          openInNewTab={openInNewTab}
        />
      }
      descriptionBlock={
        <ProductCardDescription
          product={product}
          quantity={quantity}
          trackProductClick={trackProductClick}
          additionalBadge={additionalBadge}
          sellingMerchant={sellingMerchant}
          totalPrice={totalPrice}
          openInNewTab={openInNewTab}
        />
      }
      quantityBlock={quantityBlock}
      deleteBlock={deleteBlock}
      priceBlock={
        <ProductCardItemPrice
          overflowHiddenLPL30D={overflowHiddenLPL30D}
          totalPrice={totalPrice}
          unitPrice={unitPrice}
          quantity={quantity}
          lowestPriorPrice={lowestPriorPrice}
          product={product}
          align="right"
        />
      }
    />
  );
};
